import { useState } from 'react';
import { mangaCategories, mangaList } from '@/mocks/manga';
import type { MangaItem } from '@/mocks/manga';
import MangaCard from './MangaCard';

const order: Record<string, string[]> = {
  all: ['m01', 'm02', 'm05', 'm06', 'm07', 'm09', 'm13', 'm14', 'm16', 'm18', 'm03', 'm11'],
  rexue: ['m01', 'm16', 'm11'],
  xuanhuan: ['m04', 'm11'],
  dushi: ['m03'],
  xanyi: ['m02', 'm09', 'm12'],
  kehuan: ['m05', 'm13', 'm18', 'm07'],
  lianai: ['m06', 'm14', 'm17'],
  gaoxiao: ['m07'],
  zhiyu: ['m08', 'm10'],
  maoxian: ['m15'],
};

export default function UpdatesSection() {
  const [active, setActive] = useState('all');

  const items = (order[active] ?? [])
    .map((id) => mangaList.find((m) => m.id === id))
    .filter((m): m is MangaItem => Boolean(m));

  return (
    <section id="updates" className="bg-background-100/40 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-950">
              <i className="ri-refresh-line text-secondary-500" />
              最新更新
            </h2>
            <p className="mt-1 text-sm text-foreground-600">按题材分类浏览，热门连载与经典完结持续更新</p>
          </div>
        </div>

        <div className="mb-6 flex flex-wrap items-center gap-2" role="tablist" aria-label="题材筛选">
          {mangaCategories.map((cat) => (
            <button
              key={cat.id}
              role="tab"
              aria-selected={active === cat.id}
              onClick={() => setActive(cat.id)}
              className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition ${
                active === cat.id
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 ring-1 ring-background-200/70 hover:text-secondary-500 hover:ring-secondary-400/40'
              }`}
            >
              <i className={cat.icon} />
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {items.map((m) => (
            <MangaCard key={m.id} item={m} />
          ))}
        </div>
      </div>
    </section>
  );
}